import React, { useState, useEffect } from "react";

import OtpInput from "react-otp-input";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { Loader2 } from "lucide-react";
import { SecuredFooter } from "./ui/secured-footer";

const AuthTwoFA = ({ onVerify, onBack, isVerifying, setIsVerifying }) => {
  const [otp, setOtp] = useState("");

  useEffect(() => {
    return () => {
      if (setIsVerifying) {
        setIsVerifying(false);
      }
    };
  }, [setIsVerifying]);

  const handleChange = (otp) => {
    setOtp(otp);
  };

  const handleCancel = () => {
    setOtp("");
    if (setIsVerifying) {
      setIsVerifying(false);
    }
    onBack?.();
  };
  return (
    <>
      <Card className="w-full pt-6 lg:pt-8 px-4 lg:px-8 shadow-lg bg-white rounded-2xl">
        <CardContent className="px-2 lg:px-6 mt-4 lg:mt-6 w-full">
          <div className="flex flex-col items-center justify-center min-h-[300px] lg:min-h-[400px] w-full lg:w-[628px] mx-auto">
            <div className="py-2 lg:py-4 text-center lg:text-left">
              <h3 className="text-2xl lg:text-[32px] font-semibold text-[#57249C] mb-2">
                Enter your 2-FA Code
              </h3>
              <p className="text-base lg:text-[20px] text-[#423E51] lg:max-w-none max-w-md">
                Enter the 6-digit verification code generated by your
                authentication app
              </p>
            </div>

            <div className="space-y-2 mb-6 lg:mb-10 mt-4 lg:mt-6 mx-auto w-full lg:w-fit flex justify-center">
              <OtpInput
                value={otp}
                onChange={handleChange}
                numInputs={6}
                separator={<span className="hidden lg:inline">-</span>}
                shouldAutoFocus
                renderInput={(props) => (
                  <input
                    {...props}
                    className="w-12 h-12 lg:w-[56px] lg:h-[56px] text-lg lg:text-xl font-bold text-center border-2 border-gray-300 rounded-xl focus:border-purple-500 focus:ring-2 focus:ring-purple-500 hover:border-purple-400 transition-all outline-none"
                  />
                )}
                inputStyle={{
                  width: "40px",
                  height: "40px",
                  margin: "0 5px",
                  fontSize: "18px",
                  borderRadius: "12px",
                  border: "1px solid hsl(var(--border))",
                  textAlign: "center",
                }}
                focusStyle={{
                  border:
                    "1px solid bg-gradient-to-tr from-purple-500 to-rose-500 hover:opacity-90",
                }}
              />
            </div>

            <div className="flex flex-col lg:flex-row items-center justify-center gap-3 w-full lg:w-auto">
              <Button
                onClick={handleCancel}
                variant="outline"
                className="rounded-full text-base lg:text-[20px] py-4 lg:py-6 px-8 lg:px-24 w-full lg:w-[48%] text-[#6D6584] font-semibold bg-white hover:opacity-90 h-12 lg:h-[64px]"
              >
                Cancel
              </Button>
              <Button
                disabled={isVerifying || otp.length !== 6}
                onClick={async () => {
                  if (onVerify && otp.length === 6) {
                    setIsVerifying(true);
                    try {
                      await onVerify(otp);
                    } catch (error) {
                      setIsVerifying(false);
                    }
                  }
                }}
                variant="outline"
                className="bg-[linear-gradient(86.72deg,#57249C_-10.66%,#EB3366_113.47%)] text-white px-6 py-4 rounded-full font-semibold hover:opacity-90 transition-opacity w-full lg:w-[48%] h-12 lg:h-[64px] text-base lg:text-[20px]"
              >
                {isVerifying && (
                  <Loader2 className="animate-spin w-4 h-4 mr-2" />
                )}
                Verify and Activate
              </Button>
            </div>
          </div>
          <SecuredFooter />
        </CardContent>
      </Card>
    </>
  );
};

export default AuthTwoFA;
